import "./Pantalla_inicio.css";
import { useEffect, useState } from "react";
import { API_URL } from "../config";

export default function Inicio() {
  const hoy = new Date();
  const alias = localStorage.getItem("alias") || "Usuario";

  const fechaFormateada = hoy.toLocaleDateString("es-MX", {
    weekday: "long",
    day: "numeric",
    month: "long"
  });

  const ultimoDia = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0).getDate();
  const diasRestantes = ultimoDia - hoy.getDate();

  const [stats, setStats] = useState([]);

  const n = (v) => Number(v) || 0;

  useEffect(() => {
    const token = localStorage.getItem("token");

    const cargarStats = async () => {
      try {
        const res = await fetch(`${API_URL}/clientes/estadisticas`, {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {})
          }
        });

        if (!res.ok) {
          console.error("Error HTTP:", res.status);
          return;
        }

        const data = await res.json();
        setStats(data.estadisticas || []);
      } catch (err) {
        console.error("Error cargando estadísticas:", err);
      }
    };

    cargarStats();
  }, []);

  // AGRUPAR POR GRUPO
  const grupos = stats.reduce((acc, row) => {
    const g = row.grupo || "Sin grupo";

    if (!acc[g]) {
      acc[g] = {
        total: 0,
        asesores: []
      };
    }

    acc[g].total += n(row.total_clientes);

    acc[g].asesores.push({
      asesor: row.asesor,
      activos: n(row.total_activos),
      inactivos: n(row.total_inactivos)
    });

    return acc;
  }, {});

  return (
    <div className="inicio-container">

      {/* ENCABEZADO */}
      <header className="inicio-header">
        <h1>Buenos días, {alias}</h1>
        <p>{fechaFormateada} — resumen</p>
        <span className="subinfo">Cierre de mes: {diasRestantes} días</span>
      </header>

      {/* MÉTRICAS PRINCIPALES */}
      <section className="metricas-grid">
        <div className="card">
          <h3>Total clientes</h3>
          <p className="valor">
            {stats.reduce((acc, row) => acc + n(row.total_clientes), 0)}
          </p>
          <span className="positivo">
            Activos: {stats.reduce((acc, row) => acc + n(row.total_activos), 0)}
          </span>
        </div>

        <div className="card">
          <h3>Clientes inactivos</h3>
          <p className="valor">
            {stats.reduce((acc, row) => acc + n(row.total_inactivos), 0)}
          </p>
          <span className="negativo">Revisar seguimiento</span>
        </div>

        <div className="card">
          <h3>Asesores</h3>
          <p className="valor">{stats.length}</p>
          <span className="meta">Incluye asesores sin clientes</span>
        </div>

        <div className="card">
          <h3>Cobranza hoy</h3>
          <p className="valor">8/10</p>
          <span className="meta">Meta: 9</span>
        </div>
      </section>

      {/* BLOQUES POR GRUPO */}
      <section className="grupos-section">
        {Object.entries(grupos).map(([nombreGrupo, data], i) => (
          <div className="grupo-card" key={i}>
            <h2 className="grupo-titulo">{nombreGrupo}</h2>
            <p className="grupo-total">Total clientes: {data.total}</p>

            <table className="mini-tabla">
              <thead>
                <tr>
                  <th>Asesor</th>
                  <th>Activos</th>
                  <th>Inactivos</th>
                </tr>
              </thead>

              <tbody>
                {data.asesores.map((a, idx) => (
                  <tr key={idx}>
                    <td>{a.asesor}</td>
                    <td>{a.activos}</td>
                    <td>{a.inactivos}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </section>

    </div>
  );
}




